import "./EmailSignature.scss"

import { InputButton } from "@skylead/component-library"
import React from "react"
import { useSelector } from "react-redux"

import { useGlobalTranslation } from "../../../utils/hook"

const EmailSignature = ({
  style = {},
  onChange = () => {},
  disabled = false,
  selectedFromEmail = "",
  accountSignature = [],
  isCampaignStep = false,
  signature,
}) => {
  const { tt } = useGlobalTranslation()
  const { mailboxes, selectedMailboxes, selectedNode } = useSelector(state => ({
    mailboxes: state.campaign.campaignDetails.mailboxes,
    selectedMailboxes: state.forms.formData.selectedMailboxes,
    selectedNode: state.campaign.selectedNode,
  }))

  const showEmailTooltipWarning =
    (!selectedFromEmail && !isCampaignStep) ||
    (isCampaignStep &&
      ((!!selectedMailboxes && !selectedMailboxes?.length) || (!!mailboxes && !mailboxes?.length)))

  const isSignatureUsed =
    !showEmailTooltipWarning &&
    (selectedNode?.data?.useDefaultSignatures?.[0] || (!!signature && !isCampaignStep))

  const onSignatureSelect = data => {
    if (!disabled) {
      if (onChange) {
        onChange(data)
      }
    }
  }

  const handleSignatureClick = () => {
    if (showEmailTooltipWarning) {
      return
    }

    if (!!accountSignature[0]?.id || isCampaignStep) {
      if (selectedNode?.data?.useDefaultSignatures?.[0]) {
        onSignatureSelect(isCampaignStep ? false : "noSignature")
      } else {
        onSignatureSelect(
          isCampaignStep ? true : isSignatureUsed ? undefined : accountSignature[0].id,
        )
      }
    }
  }

  const getTooltipText = () => {
    if (showEmailTooltipWarning) {
      return tt("email.signature.input.tooltip.text")
    }
    if (!isCampaignStep && !accountSignature[0]?.id) {
      return tt("signature")
    }
    return isSignatureUsed ? "Signature on" : "Signature off"
  }

  return (
    <div>
      <div className="email-signature" style={style}>
        <div className="signature-selector">
          <InputButton
            icon="ballpen-20"
            onClick={handleSignatureClick}
            tooltipObj={{
              text: getTooltipText(),
              topPos: showEmailTooltipWarning ? 63 : 45,
              alignItemAbove: true,
            }}
            active={isSignatureUsed}
            disabled={showEmailTooltipWarning || (!isCampaignStep && !accountSignature[0]?.id)}
          />
        </div>
      </div>
    </div>
  )
}

// EmailSignature.propTypes = {
//   style: PropTypes.instanceOf(Object),
//   onChange: PropTypes.func,
//   disabled: PropTypes.bool,
//   selectedFromEmail: PropTypes.string,
//   accountSignature: PropTypes.instanceOf(Array),
//   isCampaignStep: PropTypes.bool,
// }

export default EmailSignature
